import { type RenderConfigClip } from "@memento/types/render-config";
import { getSegmentTypeHumanLowercase } from "@memento/library/segment";
import { useEditor } from "src/components/Renderer/RendererProvider";
import { ToggleBlock } from "src/components/Renderer/ToggleBlock";

type EditClipSkipFaceProps = {
  clip: RenderConfigClip;
};

export const EditClipSkipFace = ({ clip }: EditClipSkipFaceProps) => {
  const { setClipSkipFace } = useEditor();

  return (
    <ToggleBlock
      label={`Exclude ${getSegmentTypeHumanLowercase(clip.type)} from face collage`}
      checked={clip.skipFace}
      onChange={(enabled) => setClipSkipFace(clip.segmentId, enabled)}
    />
  );
};
